import { Box } from '@mui/material';
import { ChipWithCustomTooltip } from 'src/components/chipWithCustomTooltip/ChipWithCustomTooltip';
import { ILocationTag } from 'src/interfaces/LocationTag';
import { lang } from 'src/utils';

interface LocationOwnerTagsProps {
  tags?: ILocationTag[];
  maxVisible?: number;
}

export const LocationOwnerTags: React.FC<LocationOwnerTagsProps> = ({
  tags = [],
  maxVisible = 2,
}) => {
  const hidden = tags.length - maxVisible;
  const hiddenTagNames = tags
    .slice(maxVisible)
    .map((tag) => tag.name)
    .join(', ');

  return (
    <Box>
      {tags.slice(0, maxVisible).map((tag) => (
        <Box
          key={tag.id}
          sx={{ margin: '0 5px 5px 0', display: 'inline-block' }}>
          <ChipWithCustomTooltip
            name={lang.locationTags}
            chipName={tag.name}
            tooltipTitle={tag.name}
            tooltipWidth={140}
            tooltipActivationWidth={62}
            tooltipPlacement="bottom"
          />
        </Box>
      ))}
      {hidden > 0 && (
        <Box sx={{ margin: '0 5px 5px 0', display: 'inline-block' }}>
          <ChipWithCustomTooltip
            name={lang.locationTags}
            chipName={`+${hidden}`}
            tooltipTitle={hiddenTagNames}
            color="success"
            tooltipPlacement="top"
            forceTooltip
          />
        </Box>
      )}
    </Box>
  );
};
